import { servicedeskPortalGroupsResource } from '@atlassian/jira-router-resources-service-desk-portal-groups/src/controllers/index.tsx';
import { useResource } from '@atlassian/react-resource-router';

const usePortalGroupsResource = () => {
	const { data, loading, error, update, refresh, clear } = useResource(
		servicedeskPortalGroupsResource,
	);
	return { data, loading, error, update, refresh, clear };
};

export default usePortalGroupsResource;
